import { useEffect } from 'react';
import { C, FONTS } from '../../tokens/design';
import { useUser } from '../../context/UserContext';
import Topbar from './Topbar';

export default function PlatformShell({ title, sub, children }) {
  const { profile } = useUser();
  const displayName = profile?.name || profile?.email || 'Admin';

  useEffect(() => {
    document.title = title ? `${title} \u2014 SSS Platform` : 'SSS Platform';
  }, [title]);

  return (
    <div style={{ flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
      <style>{`
        @keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
      `}</style>
      <Topbar title={title} sub={sub} extraPill={
        <div style={{ display: 'flex', alignItems: 'center', gap: 6, padding: '5px 12px', borderRadius: 6, background: `${C.pur}10`, border: `1px solid ${C.pur}33` }}>
          <span style={{ fontSize: 10, fontWeight: 600, color: C.pur, fontFamily: FONTS.mono }}>Platform Admin</span>
          <span style={{ fontSize: 9, color: C.t2, fontFamily: FONTS.mono }}>{displayName}</span>
        </div>
      } />
      <main style={{ flex: 1, overflowY: 'auto', padding: '20px' }}>
        <div style={{ maxWidth: 1280, margin: '0 auto', animation: 'fadeIn 0.2s ease' }}>
          {children}
        </div>
      </main>
    </div>
  );
}
